import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { effectivePeriods } from '@shared/utilities/functions';
import { DateTime } from 'luxon';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-faq-more-info',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './faq-more-info.component.html',
  styleUrl: './faq-more-info.component.scss'
})
export class FaqMoreInfoComponent {


  effectivePeriods: any[] = [];

  constructor(
    private config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    const dataCode = this.config.data;
    // Use dataCode to determine which data to load in the dialog content
    if (
      dataCode.data[0].code === 'flt-01-008' ||
      dataCode.data[0].code === 'flt-00-002' ||
      dataCode.data[0].code === 'flt-00-003'
    ) {
      this.effectivePeriods = effectivePeriods();
    }
  }

  convertDate(date?: string): string | undefined {
      if (date) {
        const dateTime = DateTime.fromISO(date, { zone: 'utc' });
        return dateTime.toFormat('dd MMM yyyy');
      }
      return undefined;
    }
}
